export default __webpack_public_path__ + "static/media/logo.c28b2678.svg";